module.exports = __webpack_public_path__ + "img/pic_location_YunlinCounty.f62783f6.png";